// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fC-z","modalContent":"gC-z","header":"hC-z","close":"iC-z"};